import VerticalNavbar from "./vertical";

const NavbarContainer = () => {
  let componentToRender;
  let value = "vertical";

  switch (value) {
    default:
      componentToRender = <VerticalNavbar />;
      break;
  }

  return <>{componentToRender}</>;
};

export default NavbarContainer;
